//
import _ from 'lodash'
import { log } from './lib/utils'
import { getComp, getTerm, getFlex, queryDBs } from './lib/pouch'
import { segmenter } from './lib/segmenter'
import { parseVerb, parseName } from './lib/mutables'
import { vowels, strongs, accents } from './lib/utils'
import { strong2weak } from './lib/augments'
import util from 'util'
// import {oxia, comb, plain} from '../../orthos'
import {oxia, comb, plain} from 'orthos'

// const path = require('path')
let clog = console.log
const d = require('debug')('app')

let wordform = process.argv.slice(2)[0] // || 'ἀργυρῷ' // false;

export function antrax (wf, compound) {
  let cwf = corrStr(wf)
  cwf = cwf.replace(/-/g, '')
  compound = true

  let sgms = segmenter(cwf)
  // segments for flexes:
  let lasts = _.uniq(sgms.map(sgm =>  { return sgm[sgm.length-1] }))
  // segments for dicts:
  let nonlasts = _.uniq(_.flatten(sgms.map(sgm =>  { return sgm.slice(0, -1) }) ))
  let pnonlasts = _.uniq(_.compact(nonlasts.map(nonlast => { return plain(nonlast) }) ))
  let added = addedStems(pnonlasts)
  // added = []  // added необходимо добавлять, потому что reg impf, aor - в словаре только слабая форма
  // а вот non-reg из added можно убрать? то есть достройка только до splain, strong-plain ?

  let plainsegs = (added.length) ? _.uniq(pnonlasts.concat(added)) : pnonlasts

  d('cwf:', cwf)
  // d('sgms:', JSON.stringify(sgms))
  d('lasts:', lasts.toString())
  // d('pnonlasts:', pnonlasts.toString())
  // d('added:', added.toString())
  d('plainsegs:', plainsegs.toString())

  return Promise.all([
    getTerm(cwf),
    queryDBs(plainsegs),
    getFlex(lasts),
    getComp(plainsegs)
  ]).then(function (res) {
    let terms = _.flatten(res[0])
    let dicts = _.flatten(res[1])

    if (compound) dicts = _.filter(dicts, dict => { return plain(corrStr(dict.rdict)).length != plain(cwf).length })
    let cmpounded = _.filter(dicts, dict => { return plain(corrStr(dict.rdict)) == plain(cwf) })

    let dterms = _.filter(dicts, dict => { return dict.term })
    dterms = dicts.concat(dterms)
    dicts = _.filter(dicts, dict => { return !dict.term })

    let comps = _.flatten(res[3])
    dicts = dicts.concat(comps)
    let flexes = _.flatten(res[2])

    dicts = _.filter(dicts, dict => { return !dict.indecl })
    let dplains = _.uniq(dicts.map(dict => { return dict.plain}))
    d('dplains---->', dplains.toString())
    d('dicts---->', dicts.length)
    let complains = _.uniq(comps.map(dict => { return dict.plain}))
    d('complains---->', complains.toString())
    d('complains---->', complains.length)

    let kdicts = _.filter(dicts, dict => { return dict.plain == 'αβαπτιστ'})
    if (kdicts.length) d('kdicts---->', kdicts.length), dicts = kdicts
    // d('flexes--->', flexes.length)
    let kflexes = _.filter(flexes, fl => { return fl.flex == 'ος-ον' && fl.ends })
    if (kflexes.length) d('kflexes--->', kflexes.length), flexes = kflexes

    let muts = main(cwf, plainsegs, sgms, pnonlasts, flexes, dicts)
    return _.compact(terms.concat(muts))
  })
}

function main(cwf, plainsegs, sgms, pnonlasts, flexes, dicts) {

  let segdicts = distributeDicts(plainsegs, dicts)
  // d('segdicts', segdicts)
  let chains = makeChains(sgms, segdicts, flexes)
  d('total chains', chains.length)

  addDicts(chains, pnonlasts, segdicts)

  let fulls = fullChains(chains)
  d('chains: ', chains.length, 'fulls: ', fulls.length)
  if (fulls.length) chains = fulls


  // соответствие dicts и flex, added dicts
  let dfchains = filterDictFlex(chains)
  d('dfchains => ', dfchains)

  let bests = selectBest(dfchains)
  d('bests =>', bests)
  d('bests =>', bests.length)
  if (!bests.length) d('no best, fulls: =>', fulls)
  return bests
}


// ADDED
function addedStems(wforms) {
  let wplain, first, added = []
  wforms.forEach(wf => {
    first = _.first(wf)
    wplain = plain(wf)

    let weaks = strong2weak[first]
    if (!vowels.includes(first)) {
      let add = ['ε', wplain].join('') // aor.sub, opt, impf for consonants
      added.push(add)
    } else if (weaks) {
      weaks.forEach(weak => {
        let add = [weak, wf.slice(1)].join('') // impfs
        added.push(add)
      })
    }
  })
  return _.uniq(added)
}

// предварительно распределяю dicts по всем plain-сегментам, включая добавочные :
function distributeDicts (plainsegs, dicts) {
  let segdicts = {}
  plainsegs.forEach(pseg => {
    let sdicts = _.filter(dicts, dict => { return pseg === dict.plain })
    segdicts[pseg] = sdicts
  })
  return segdicts
}

function makeChains (sgms, segdicts, flexes) {
  let chains = []
  sgms.forEach(segs => {
    let lastseg = _.last(segs)
    let segflexes = _.filter(flexes, flex => { return flex.flex === lastseg} )
    if (!segflexes.length) return

    let psegs = segs.slice(0, -1)
    let weight = 0
    let chain = []
    psegs.forEach((seg, idx) => {
      let pseg = plain(seg)
      let pdicts = segdicts[pseg]
      let dicts = []
      let prefs, comps, conns, names, all
      if (!idx) {
        prefs = _.filter(pdicts, pdict => { return pdict.pref || pdict.name || pdict.comp && pdict.header })
        comps = _.filter(pdicts, pdict => { return pdict.comp && pdict.header })
        if (comps.length) weight += 1
        dicts = dicts.concat(prefs)
      } else if (idx < psegs.length-1) {
        names = _.filter(pdicts, pdict => { return pdict.comp || pdict.name })
        comps = _.filter(pdicts, pdict => { return pdict.comp })
        conns = _.filter(pdicts, pdict => { return pdict.connector })
        if (comps.length) weight += 1
        if (conns.length) weight += 1
        dicts = dicts.concat(names)
      } else if (idx == psegs.length-1) {
        all = _.filter(pdicts, pdict => { return pdict.comp || pdict.name || pdict.verb })
        comps = _.filter(pdicts, pdict => { return pdict.comp })
        if (comps.length) weight += 1
        dicts = dicts.concat(all)
      }
      let oseg = {seg: seg, dicts: dicts, weight: weight }
      chain.push(oseg)
    })

    chain.push({seg: lastseg, flexes: segflexes})
    chains.push(chain)
  })
  return chains
}

// ADDED
function addDicts(chains, pnonlasts, segdicts) {
  chains.forEach(segs => {
    let penult = segs[segs.length-2]
    if (!penult.dicts) d('NO SDICTS', segs)
    let seg = penult.seg
    seg = plain(seg)
    let first = _.first(seg)
    // if (penult.dicts.length) return // уже есть значение, добавлять не нужно - нет, так нельзя, ἦγον имеет ненужный ηγ и не пустит
    let sdicts = _.clone(penult.dicts)

    let weaks = strong2weak[first]
    if (!vowels.includes(first)) {
      let added = ['ε', seg].join('') // aor.sub, opt, impf from ind
      addDictCarefully(pnonlasts, segdicts, sdicts, added, 'added')
    } else if (first == 'ε') { // pas.aor.sub - βλέπω  - ἔβλεψα - ἐβλεφθῶ - dict plain βλε
      if (seg.length < 2) return
      let added = seg.slice(1)
      addDictCarefully(pnonlasts, segdicts, sdicts, added, 'sliced')
    } else if (first == 'η') { // mp.impf.ind - ἠβουλόμην, ἐβουλόμην
      if (seg.length < 2) return
      let added = seg.slice(1)
      addDictCarefully(pnonlasts, segdicts, sdicts, added, 'sliced')
    }
    if (weaks) {
      weaks.forEach(weak => {
        let stem = seg.slice(1)
        let added = [weak, stem].join('')
        addDictCarefully(pnonlasts, segdicts, sdicts, added, 'sliced')
      })
    }
    penult.dicts = _.compact(_.flatten(sdicts))
  })
}

function addDictCarefully(pnonlasts, segdicts, sdicts, added, mark) {
  let adicts = segdicts[added]
  adicts = _.filter(adicts, dict => { return dict.verb })
  if (!adicts || !adicts.length) return
  adicts.forEach(adict => {
    // есть случай, когда plain включен в исходные pnonlasts, но не в данной chain - ἐδείκνυν, plain δεικνυ в 3-chain
    // if (!pnonlasts.includes(adict.plain)) adict[mark] = true
    // но без проверки на pnonlasts.includes отвалится что-то важное потом?
    adict[mark] = true
  })
  sdicts.push(adicts)
}

function fullChains(chains) {
  let fulls = []
  chains.forEach(segs => {
    let full = true
    let dsegs = segs.slice(0, -1)
    dsegs.forEach(seg => {
      if (!seg.dicts.length) full = false
    })
    if (full) fulls.push(segs)
  })
  return fulls
}

function filterDictFlex (rchains) {
  let chains = []
  rchains.forEach(rchain => {
    // d('rch', rchains)
    let lastseg = _.last(rchain)
    let flexseg = lastseg.seg
    let flexes = lastseg.flexes
    // let segs = rchain.slice(0, -1)
    let head = rchain.slice(0, -2)
    // if (!segs.length) return
    let penult = rchain.slice(-2, -1)[0]
    log('penultDs', penult.dicts.length)
    let penseg = penult.seg
    let seg = [penseg, '+', flexseg].join('')

    let names = _.filter(penult.dicts, dict => { return dict.name })
    let nflexes = _.filter(flexes, flex => { return flex.name })
    let vflexes = _.filter(flexes, flex => { return flex.name })
    let aflexes = _.filter(flexes, flex => { return flex.adv })
    log('Ns', names.length)
    log('nFs', nflexes.length)

    // let vchains = parseVerb(seg, segs, flexes)
    // chains.push(vchains)
    // let nchains = parseName(seg, segs, flexes)

    let ends = []
    let ndicts = parseName(names, nflexes)
    ends = ends.concat(ndicts)
    ends = _.compact(ends)
    if (!ends.length) return
    let newseg = {seg: seg, dicts: ends, weight: penult.weight}
    head.push(newseg)
    // log('NEWCH:', head)
    chains.push(head)
    log('CHS:', chains.length)
  })
  log('CHAINS:', chains.length)
  return chains
}

function selectBest(chains) {
  let min = _.min(chains.map(chain => {  return chain.length } ) )
  let shortests = _.filter(chains, chain => { return chain.length == min })
  // d('MIN', min, shortests.length)
  let heaviest = _.max(shortests.map(chain=> { return _.sum(chain.map(seg=> { return seg.weight })) }) )
  // d('HVST', heaviest)
  let havies = _.filter(shortests, chain=>{ return _.sum(chain.map(seg=> { return seg.weight })) == heaviest })
  return havies
}

function cleanStr(row) {
  let clean = row.trim()
  clean = clean.replace(/ᾰ/gi, 'α').replace(/ᾱ/gi, 'α').replace(/ῑ/gi, 'ι').replace(/ῐ/gi, 'ι').replace(/ῠ/gi, 'υ').replace(/ῡ/gi, 'υ')
  clean = clean.replace(/Ῐ/gi, 'Ι').replace(/Ῑ/gi, 'Ι')
  clean = clean.replace(/̆/gi, '')
  return clean
}

function corrStr(wf) {
  let clwf = cleanStr(wf)
  let cwf = comb(clwf)
  return oxia(cwf)
}
